function setupSportsHubHome(root = document) {
  root.querySelectorAll('.shh-hero').forEach((hero) => {
    if (hero.dataset.ready) return;
    hero.dataset.ready = 'true';
    hero.querySelectorAll('[data-sh-swatch]').forEach((swatch) => {
      swatch.addEventListener('click', (event) => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const key = swatch.dataset.shSwatch;
        hero.querySelectorAll('[data-sh-figure]').forEach((figure) => {
          figure.hidden = figure.dataset.shFigure !== key;
        });
        hero.querySelectorAll('[data-sh-swatch]').forEach((item) => {
          item.classList.toggle('is-active', item === swatch);
          if (item === swatch) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
        hero.querySelector('[data-sh-support-link]').href = swatch.href;
        hero.querySelector('[data-sh-support-price]').firstChild.textContent = swatch.dataset.shPrice + ' ';
      });
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setupSportsHubHome());
else setupSportsHubHome();
document.addEventListener('shopify:section:load', (event) => setupSportsHubHome(event.target));

